export default class PackageService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('geoblocking_private_ip', params)
	}

	createEntity(params){
		return this.apiService.callPost('geoblocking_private_ip', params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('geoblocking_private_ip/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/GeoblockingPrivateIpService.js